import { transformErrorWithAlert } from '../redux/helpers/transform-error-with-alert';
import { history, store } from '../redux/configure-store';
import { ApiErrorResponse } from '../types/api';
import { Paths } from '../routes/paths-enum';
import { setIsButtonDisabled } from '../redux/modules/app';

export const showAlertAndRedirect = (
  response: ApiErrorResponse,
  message: string,
  path?: string,
) => {
  store.dispatch(setIsButtonDisabled(true));

  setTimeout(() => {
    history.push(path || Paths.HOME);
    store.dispatch(setIsButtonDisabled(false));
  }, 3000);

  return transformErrorWithAlert({ response, message });
};
